import { FC } from "react";
import { FormattedMessage } from "react-intl";
import PlusIcon from "~/assets/Plus.svg";
import { ConditionalTooltip } from "~/components/ConditionalTooltip";
import { Button } from "~/components/ui/button";
import { trackEvent } from "~/utils/analytics";
import { CreateCaseDialog } from "./CreateCaseDialog";

interface CreateCaseButtonProps {
  disabled?: boolean;
  isFirstCase?: boolean;
}

export const CreateCaseButton: FC<CreateCaseButtonProps> = ({
  disabled,
  isFirstCase,
}) => {
  return (
    <ConditionalTooltip condition={disabled}>
      <CreateCaseDialog
        isFirstCase={isFirstCase}
        TriggerButton={
          <Button
            className="bg-blue-600 hover:bg-blue-700 cursor-pointer"
            size="sm"
            onClick={() =>
              trackEvent({ eventName: "app/cases/create_case.button/click" })
            }
            disabled={disabled}
          >
            <img className="mr-2" src={PlusIcon} width="17" height="16" />
            <FormattedMessage
              id={"casesList.createCase"}
              defaultMessage={"Create Case"}
            />
          </Button>
        }
      />
    </ConditionalTooltip>
  );
};
